import React, { createContext, useContext, useState, useEffect } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [merchant_id, setMerchantId] = useState(null);
  const [cliente_id, setClienteId] = useState(null); // Almacena el cliente asociado
  const [authToken, setAuthToken] = useState(localStorage.getItem("authToken") || null);
  const [authLoading, setAuthLoading] = useState(true);
  const API_BASE_URL = "http://127.0.0.1:5000";

  useEffect(() => {
    if (authToken) {
      validateSession();
    } else {
      setAuthLoading(false); // No hay token, salte el fetch
    }
  }, [authToken]);

  const validateSession = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/auth/validate`, {
        method: "POST",
        headers: { 
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`, // Token enviado al servidor
        },
      });

      if (!response.ok) {
        throw new Error("Sesión inválida o expirada.");
      }

      const data = await response.json();
      console.log("Datos validados:", data); // Debugging
      setMerchantId(data.merchant_id);
      setClienteId(data.cliente_id);
    } catch (error) {
      console.error("Error en la validación de sesión:", error);
      logout();
    } finally {
      setAuthLoading(false);
    }
  };

  const login = async (email, password) => {
    setAuthLoading(true);
    try {
      const response = await fetch(`${API_BASE_URL}/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      if (!response.ok) {
        throw new Error("Credenciales inválidas.");
      }

      const data = await response.json();
      console.log("Datos de autenticación recibidos:", data);

      localStorage.setItem("authToken", data.token);
      setAuthToken(data.token);
      setMerchantId(data.merchant_id);
      setClienteId(data.cliente_id);
    } catch (error) {
      console.error("Error al iniciar sesión:", error);
      throw error;
    } finally {
      setAuthLoading(false);
    }
  };

  const logout = () => {
    setAuthToken(null);
    setMerchantId(null);
    setClienteId(null);
    localStorage.removeItem("authToken");
  };

  return (
    <AuthContext.Provider
      value={{
        merchant_id,
        cliente_id,
        authToken,
        login,
        logout,
        authLoading,
        setMerchantId,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth debe usarse dentro de AuthProvider");
  }
  return context;
};
